import { createFileRoute, Link } from '@tanstack/react-router'
import { Logo } from '@/components/Logo'

export const Route = createFileRoute('/about')({
  component: About,
})

function About() {
  return (
    <main className="bg-muted min-h-screen py-12">
      <header className="mx-auto mb-12 max-w-3xl px-8">
        <Link to="/" aria-label="Go to homepage">
          <Logo size="md" />
        </Link>
      </header>

      <article className="mx-auto max-w-3xl px-8">
        <h1 className="text-foreground mb-4 text-4xl font-bold">About Markur</h1>
        <p className="text-muted-foreground mb-12 text-base">
          More content coming soon. In the meantime, here's the short version.
        </p>

        <div className="text-foreground space-y-10">
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">Our mission</h2>
            <p>
              Markur is your personal AI health coach. We help you log every signal that matters and
              surface predictive insights from the patterns your body creates.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">Trademarks</h2>
            <p className="text-muted-foreground text-sm">
              Google Play and the Google Play logo are trademarks of Google LLC.
            </p>
          </section>
        </div>
      </article>
    </main>
  )
}
